import {GetExamsBookedParams} from 'domain/usecases';
import {makeGetExamsBooked} from 'main/factories/usecases/private/booked-flow/remote-exams/get-exams-booked-factory';

export async function getExamsBooked(params: GetExamsBookedParams) {
	const response = await makeGetExamsBooked().get(params);

	return response;
}
